import {crud} from 'app/lib/action';
import {GET_UNITS} from '../constants/actionTypes';

export default crud(GET_UNITS);